/**
 * Small fire-and-forget analytics helper for the RendPleX AI Advisor chat.
 * Shared so any chat sub-component (message actions, feature chips, etc.)
 * can log an event without prop-drilling a callback from the top of the tree.
 *
 * `keepalive: true` lets the request survive an immediate navigation, which
 * is exactly what we need when a user taps a feature chip and jumps to a
 * different route in the very next tick.
 */
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export function fireChatAnalytics(event, property_key, meta = {}) {
  try {
    fetch(`${BACKEND_URL}/api/property/chat/analytics`, {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ event, property_key, meta }),
      keepalive: true,
    }).catch(() => {});
  } catch {
    // no-op — analytics must never break UX
  }
}
